import { showToast } from "./toastActions"
import { noterVersionServeur } from "../../utilities/versionDeploiement"

// Plomberie partagée des appels API : gestion d'erreur uniforme.
//
// Toute erreur d'appel (Response non-2xx jetée par handleErrors, ou panne
// réseau) est normalisée en un payload unique qui sert à la fois :
// - au toast ({message, level}),
// - aux modaux V2 ({message, level, fields}),
// - aux lecteurs legacy ({msg, status}) — zéro rework des anciennes pages.

export const GENERIC_ERROR_MESSAGE = "Une erreur est survenue."

// Jette la Response brute sur un status non-2xx : le .catch reçoit ainsi le
// status ET le corps (encore lisible) pour normalisation.
export function handleErrors(response) {
	// Rechargement auto au deploy : toute réponse porte la version déployée.
	if (response && response.headers && response.headers.get)
		noterVersionServeur(response.headers.get("X-SvpApp-Version"))
	if (!response.ok) {
		throw response
	}
	return response
}

// Extrait un message lisible de n'importe quelle enveloppe rencontrée pendant
// la migration : {message, level, fields} (standard), {msg, message, level,
// status} (ex-getError), {"error": "..."} (anciens outliers).
function messageFromBody(body) {
	if (!body || typeof body !== "object") return ""
	if (typeof body.message === "string" && body.message) return body.message
	if (typeof body.msg === "string" && body.msg) return body.msg
	if (typeof body.error === "string" && body.error) return body.error
	if (body.error && typeof body.error === "object")
		return body.error.message || body.error.msg || ""
	return ""
}

// Normalise n'importe quelle erreur d'appel API en payload redux unique.
export async function normalizeApiError(err) {
	let body = null
	let httpStatus = null
	if (err && typeof err.json === "function") {
		httpStatus = err.status || null
		try {
			body = await err.json()
		} catch (e) {
			body = null // corps non-JSON (page HTML, réponse vide…)
		}
	}
	const message = messageFromBody(body) || GENERIC_ERROR_MESSAGE
	const fields = (body && body.fields) || {}
	return {
		message,
		level: (body && body.level) || "danger",
		fields,
		// Clés de compat : les composants legacy (SaveModal & co) lisent
		// error.msg / error.status ("Erreur", libellé historique de getError).
		msg: message,
		status: (body && body.status) || "Erreur",
		httpStatus,
		errorFields: fields,
	}
}

// Toast standard depuis un payload normalisé.
export function showToastFromError(payload) {
	return showToast(payload.level, payload.message)
}

// Catch standard d'un thunk API : stocke l'erreur normalisée en redux puis
// toaste (sauf opts.silent — flux modaux V2 et tâches de fond).
// Usage : .catch(catchApiError(dispatch, fetchRdvsError))
// Résout undefined : les appelants qui font thunk().then((json) => ...)
// gardent leur distinction succès (json) / échec (undefined).
export function catchApiError(dispatch, errorActionCreator, opts = {}) {
	return (err) =>
		normalizeApiError(err).then((payload) => {
			if (errorActionCreator) dispatch(errorActionCreator(payload))
			if (!opts.silent) dispatch(showToastFromError(payload))
		})
}
